<template lang="pug">
v-card.custom-card(outlined)
  .d-flex.align-center.gap-2.seletor-header
    v-select.modulo-select.preview-field(
      :label="label",
      :value="value",
      @change="$emit('input', $event)",
      :items="itens",
      :item-text="itemText",
      :item-value="itemValue",
      outlined,
      dense,
      hide-details
    )
    v-spacer
</template>

<script>
export default {
  name: "SeletorContextoCard",

  props: {
    label: {
      type: String,
      default: "Módulo"
    },
    value: {
      type: [String, Number],
      default: null
    },
    itens: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: "text"
    },
    itemValue: {
      type: String,
      default: "value"
    }
  }
};
</script>

<style scoped>
.custom-card {
  width: 100%;
  background-color: #fff;
  border: 1px solid #d9e2ec !important;
  border-radius: 18px 6px 18px 6px !important;
  box-shadow: 0 2px 8px rgba(15, 42, 77, 0.08) !important;
}

.seletor-header {
  min-height: 64px;
  padding: 0 18px;
  display: flex;
  align-items: center;
}

.gap-2 {
  gap: 8px;
}

.modulo-select {
  max-width: 280px;
  flex: 0 0 auto;
}

.preview-field {
  border-radius: 6px !important;
  background-color: #fff;
}

.preview-field.v-input--is-focused .v-input__slot {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.15);
}

.preview-field .v-input__slot:hover {
  border-color: #b1bac4;
}

.preview-field .v-input__slot,
.preview-field .v-select__selection {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  min-height: 36px !important;
}

.preview-field .v-input__slot {
  min-height: 36px !important;
}

.preview-field .v-input__append-inner .v-icon {
  color: #57606a;
  font-size: 18px;
}

.preview-field .v-label {
  color: #8a94a3;
  font-size: 13px;
}
</style>
